import { InventoryWebComponent } from './component/InventoryWebComponent';
import { WEB_COMPONENT_WIDGET_INVENTORY } from '../webcomponents.constants';

export { InventoryWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_INVENTORY, InventoryWebComponent);
